// extracted by mini-css-extract-plugin
export default {"product__container":"Result_product__container__qcsuW"};